import { render, staticRenderFns } from "./CategoryShopIndex.vue?vue&type=template&id=43b4bd20&scoped=true"
import script from "./CategoryShopIndex.vue?vue&type=script&lang=js"
export * from "./CategoryShopIndex.vue?vue&type=script&lang=js"
import style0 from "./CategoryShopIndex.vue?vue&type=style&index=0&id=43b4bd20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b4bd20",
  null
  
)

export default component.exports